import { useNavigate } from 'react-router-dom';
import { Button, toast } from '@scholastic/mockingjay';
import { useGetMeApiWithSessionContext } from 'eds-common/api/v2';
import UserSolid from '@/assets/images/user-solid.svg';
import { signOut } from '@/services/auth/auth-service';
import { endAppSession } from '@/services/app-session/end-app-session';
import { queryClient } from '@/routes';

export function ImpersonationBanner() {
  const navigate = useNavigate();
  const { data: meResponse } = useGetMeApiWithSessionContext();

  const me = meResponse?.userContext;

  const handleLogout = () => {
    endAppSession({ reason: 'user' })
      .then(() => signOut())
      .then(() => {
        toast.success(
          'You have been signed out of your impersonated session.',
          { position: 'top-center' }
        );
      })
      .catch((err) => console.error(err))
      .finally(() => {
        queryClient.clear();
        navigate('/sign-in');
      });
  };

  if (!meResponse?.isImpersonated || !me) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-4 bg-blue-900 px-4 py-3 text-white shadow-header tablet:px-10">
      <span className="flex items-center gap-3 text-sm tablet:text-lg">
        <UserSolid aria-hidden />
        You are Impersonating {me.givenName} {me.familyName[0]}
      </span>
      <Button
        className="h-7 [&>span]:text-sm"
        variant="tertiary"
        onClick={handleLogout}
      >
        End Session
      </Button>
    </div>
  );
}
